exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:HelveticaNeue,Helvetica}a{cursor:pointer}h5{color:#edae61;font-weight:600;font-size:18px}h4,h5{text-transform:uppercase}h4{color:#a2abbd;font-weight:800;font-size:24}.container{background-color:#21212b;width:70%;padding:100px;margin-top:100px}.row{margin:0 auto;margin-top:100px;width:70%}.card{border-radius:25px;color:#a2abbd;border-color:transparent;margin-bottom:50px;height:465px}.card-header{border-radius:25px 25px 0 0!important;background-color:#edae61;color:#fff}.card-header h2{display:inline-block;font-size:24px;font-weight:700}.card-header .fa{font-size:25px;font-weight:lighter;margin-top:5px}.card-body{border-bottom:1px solid #a2abbd!important}.card-body,.card-footer{background-color:#2a2a35}.card-footer{border-radius:0 0 25px 25px!important;color:#a2abbd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ffbe248","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 16
// module chunks = 0